import FOOTER_PAGE_TYPE from '@/constants/footer';
import HEADER_PAGE_TYPE from '@/constants/header';
import { isNextServer, uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import React from 'react';
import HeaderFooter from './headerFooter';

interface Props {
  children: React.ReactNode;
  pageType: HEADER_PAGE_TYPE;
  footerPageType: FOOTER_PAGE_TYPE;
  disabled?: boolean;
}

export const HeaderFooterWrapper: React.FC<Props> = ({
  children,
  pageType,
  footerPageType,
  disabled = false,
}) => {
  const getUserAgent = () => {
    if (isNextServer()) {
      const { headers } = require('next/headers');
      const headersList = headers();
      return headersList.get('user-agent') || '';
    }
    return navigator.userAgent;
  };

  const userAgent = getUserAgent();
  if (uaParse(userAgent).isInJoybuyApp) {
    return <div>{children}</div>;
  }

  return (
    <HeaderFooter pageType={pageType} footerPageType={footerPageType} disabled={disabled}>
      {children}
    </HeaderFooter>
  );
};

export default HeaderFooterWrapper;
